import * as React from "react";
// import { pure } from 'recompose';
import CheckBoxGrid from "@tunnel-components/@sharded/@widgets/checkbox/component";
// import * as shortid from 'shortid';
import * as Lodash from "lodash";
import * as cx from "classnames";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  const {
    labelIncident,
    labelSTOPPEDError5,
    onChangeIncident,
    labelDureeminimal,
    onChangeElement,
    onChangeSpeed,
    onChangeDuration,
    minDurations,
    maxSpeeds,
    nbElements,
    minDuration,
    maxSpeed,
    nbElement,
    disabled,
    incidentLabel,
    index,
    id,
    checked,
    labelSLOWFirst,
    labelSTOPPEDFirst,
    labelSLOWSecond,
    labelSTOPPEDSecond,
    labelSLOWError,
    labelSTOPPEDError,
    checkedSTOPPEDError9,
    checkedSTOPPEDError7,
    checkedSTOPPEDError5,
    checkedSTOPPEDError1,
    checkedSLOWError,
    nameInput,
    authorization,
    nameChecked,
  } = props;

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const paramauthorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.INCIDENTSETTINGSRULES,
  ]);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <div className={cx("globalIncident", { globalIncidentRules: true })}>
      <div className="incidentContentTypes">
        <div className="left infosIncident">
          <p className="titleIncident">{labelIncident}</p>
          {!Lodash.isNull(maxSpeed) && (
            <div
              className="incidentRules"
              style={{ overflow: "hidden", height: "auto" }}
            >
              {Lodash.isEqual(incidentLabel, "SLOW") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSLOWFirst}
                </span>
              )}
              {!Lodash.isEqual(incidentLabel, "CONGESTION") && (
                <input
                  className={cx("left", { noBorder: !paramauthorization })}
                  name={nameInput}
                  disabled={disabled || !paramauthorization}
                  value={maxSpeeds || 0}
                  onChange={onChangeSpeed}
                  autoComplete="off"
                  autoFocus={true}
                />
              )}
              {Lodash.isEqual(incidentLabel, "SLOW") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSLOWSecond}
                </span>
              )}
            </div>
          )}
          {!Lodash.isNull(minDuration) && (
            <div
              className="incidentRules"
              style={{ overflow: "hidden", height: "auto" }}
            >
              {Lodash.isEqual(incidentLabel, "SLOW") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelDureeminimal}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "STOPPED") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDFirst}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "HUMAN") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelDureeminimal}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "OBJECT") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelDureeminimal}
                </span>
              )}
              {!Lodash.isEqual(incidentLabel, "CONGESTION") && (
                <input
                  className={cx("left", { noBorder: !paramauthorization })}
                  name={nameInput}
                  disabled={disabled || !paramauthorization}
                  value={minDurations || 0}
                  onChange={onChangeDuration}
                  autoComplete="off"
                  autoFocus={true}
                />
              )}

              {Lodash.isEqual(incidentLabel, "SLOW") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDSecond}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "STOPPED") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDSecond}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "HUMAN") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDSecond}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "OBJECT") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDSecond}
                </span>
              )}
            </div>
          )}

          {!Lodash.isNull(nbElement) && (
            <div
              className="incidentRules"
              style={{ overflow: "hidden", height: "auto" }}
            >
              {Lodash.isEqual(incidentLabel, "SLOW") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSLOWFirst}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "STOPPED") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDFirst}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "HUMAN") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelDureeminimal}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "OBJECT") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelDureeminimal}
                </span>
              )}
              {!Lodash.isEqual(incidentLabel, "CONGESTION") && (
                <input
                  className={cx("left", { noBorder: !paramauthorization })}
                  name={nameInput}
                  disabled={disabled || !paramauthorization}
                  value={nbElements || 0}
                  onChange={onChangeElement}
                  autoComplete="off"
                  autoFocus={true}
                />
              )}
              {Lodash.isEqual(incidentLabel, "SLOW") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSLOWSecond}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "STOPPED") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDSecond}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "HUMAN") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDSecond}
                </span>
              )}
              {Lodash.isEqual(incidentLabel, "OBJECT") && (
                <span
                  className="left label"
                  style={{ width: "208px", lineHeight: "27px" }}
                >
                  {labelSTOPPEDSecond}
                </span>
              )}
            </div>
          )}
        </div>
        <div
          className={cx("left infosIncidentAction", {
            activeInput: !authorization,
          })}
        >
          <div className="inputCheckBoxIncident" key={index}>
            <CheckBoxGrid
              // key={shortid.generate()}
              id={id}
              name={nameChecked}
              disabled={!authorization}
              checked={checked}
              onChecked={onChangeIncident}
            />
          </div>
        </div>
      </div>
      <div className="clearfix" />
      {checkedSLOWError && Lodash.isEqual(incidentLabel, "SLOW") && (
        <p className="errorCreated">{labelSLOWError}</p>
      )}
      {checkedSTOPPEDError5 && Lodash.isEqual(incidentLabel, "OBJECT") && (
        <p className="errorCreated">{labelSTOPPEDError5}</p>
      )}
      {checkedSTOPPEDError9 && Lodash.isEqual(incidentLabel, "HUMAN") && (
        <p className="errorCreated">{labelSTOPPEDError}</p>
      )}
      {checkedSTOPPEDError1 && Lodash.isEqual(incidentLabel, "SLOW") && (
        <p className="errorCreated">{labelSTOPPEDError}</p>
      )}
      {checkedSTOPPEDError7 && Lodash.isEqual(incidentLabel, "STOPPED") && (
        <p className="errorCreated">{labelSTOPPEDError}</p>
      )}
    </div>
  );
};

// initialisation des props

Component.defaultProps = {
  // nameInput:"",
  checked: false,
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  labelIncident: string;
  onChangeIncident?: any;
  id?: any;
  checkedCONGESTIONError?: boolean;
  checkedSLOWError?: boolean;
  checkedSTOPPEDError9?: boolean;
  checkedSTOPPEDError7?: boolean;
  checkedSTOPPEDError5?: boolean;
  checkedSTOPPEDError1?: boolean;

  value?: any;
  values?: any;

  minDuration?: any;
  maxSpeed?: any;
  nbElement?: any;

  minDurations?: any;
  maxSpeeds?: any;
  nbElements?: any;

  authorization?: any;
  checked?: boolean;
  onChangeRules?: any;
  nameInput?: any;
  nameChecked?: string;
  incidentLabel?: any;
  labelCONGESTIONFirst?: string;
  labelSLOWFirst?: string;
  labelDureeminimal?: string;
  labelSTOPPEDFirst?: string;
  labelCONGESTIONSecond?: string;
  labelSLOWSecond?: string;
  labelSTOPPEDSecond?: string;
  labelCONGESTIONError?: string;
  labelSLOWError?: string;
  labelSTOPPEDError?: string;
  index?: any;
  disabled?: boolean;
  onChangeElement?: any;
  onChangeSpeed?: any;
  onChangeDuration?: any;
  labelSTOPPEDError5?: string;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/supervision/incidents/component.tsx